export default __webpack_public_path__ + "static/media/right-arrow.2e110e9e.svg";